import { useEffect, useRef, useState, RefObject } from 'react';
import { Overlay } from 'react-bootstrap';

interface InnerCircleProps {
  centerX: number;
  centerY: number;
  radius: number;
  data: any;
  container: RefObject<HTMLElement>;
}

function InnerCircle({
  centerX,
  centerY,
  radius,
  data,
  container,
}: InnerCircleProps) {
  const { startAngle, endAngle, value, tag, color: initColor } = data;
  const color = initColor === 'transparent' ? '#EAECF0' : '#0080A8';
  const angleInDegrees = (endAngle - startAngle) / 2 + startAngle;
  const angleInRadians = (angleInDegrees * Math.PI) / 180.0;
  const target = useRef(null);
  const [show, setShow] = useState(false);

  const polarToCartesianCircle = () => ({
    cx: centerX + radius * Math.cos(angleInRadians),
    cy: centerY + radius * Math.sin(angleInRadians),
  });

  useEffect(() => {
    if (target.current) {
      setShow(true);
    }
    return () => setShow(false);
  }, [target]);

  return (
    value !== 0 && (
      <>
        <g>
          <circle
            ref={target}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...polarToCartesianCircle()}
            r="4"
            fill="transparent"
            className="data-label-circle"
          />
        </g>
        <Overlay
          target={target.current}
          show={show}
          transition={false}
          container={container}
          placement={startAngle < 90 ? 'right' : 'left'}
        >
          <div className="tooltip-content">
            <div className="circle" style={{ backgroundColor: color }} />
            <div>
              <strong>{value}</strong> <span>{tag}</span>
            </div>
          </div>
        </Overlay>
      </>
    )
  );
}

export default InnerCircle;
